import React, { Component } from "react";
import styled from "styled-components";
import {
  GridContainer,
  GridContent,
  SectionTitle,
  InnerContent,
} from "../../../pages/Ems/Main";

class SystemInfo extends Component {
  // constructor(props) {

  // }

  render() {
    return (
      <>
        <GridContent>
          <SectionTitle>태양광</SectionTitle>
          <InnerContent style={{ height: "calc(100% - 50px)" }}>
            <ValueBox>
              <dl>
                <dt>
                  <img
                    src="images/ctors/ems/database-power.png"
                    alt="생산전력"
                  />
                  생산 전력
                </dt>
                <dd>2 kW</dd>
              </dl>
            </ValueBox>
            <ValueBox>
              <dl>
                <dt>
                  <img
                    src="images/ctors/ems/database-power.png"
                    alt="생산전력"
                  />
                  운용률
                </dt>
                <dd>22 %</dd>
              </dl>
            </ValueBox>
            <ValueBox>
              <dl>
                <dt>
                  <img
                    src="images/ctors/ems/database-power.png"
                    alt="생산전력"
                  />
                  일간 발전량
                </dt>
                <dd>6 kW</dd>
              </dl>
            </ValueBox>
          </InnerContent>
        </GridContent>
        <GridContent>
          <SectionTitle>전력기기</SectionTitle>
          <InnerContent style={{ height: "calc(100% - 50px)" }}>
            <ValueBox>
              <dl>
                <dt>
                  <img
                    src="images/ctors/ems/database-power.png"
                    alt="생산전력"
                  />
                  수요 전력
                </dt>
                <dd>1 kW</dd>
              </dl>
            </ValueBox>
            <ValueBox>
              <dl>
                <dt>
                  <img
                    src="images/ctors/ems/database-power.png"
                    alt="생산전력"
                  />
                  일간 소비량
                </dt>
                <dd>4 kWh</dd>
              </dl>
            </ValueBox>
          </InnerContent>
        </GridContent>
        <GridContent>
          <SectionTitle>배터리</SectionTitle>
          <GridContainer gridFr={"1fr 1fr 1fr"}>
            <InnerContent>
              <ValueBox>
                <dl>
                  <dt>
                    <img
                      src="images/ctors/ems/database-power.png"
                      alt="생산전력"
                    />
                    운용률
                  </dt>
                  <dd>100 %</dd>
                </dl>
              </ValueBox>
              <ValueBox>
                <dl>
                  <dt>
                    <img
                      src="images/ctors/ems/database-power.png"
                      alt="생산전력"
                    />
                    일간 충전량
                  </dt>
                  <dd>1 kWh</dd>
                </dl>
              </ValueBox>
              <ValueBox>
                <dl>
                  <dt>
                    <img
                      src="images/ctors/ems/database-power.png"
                      alt="생산전력"
                    />
                    일간 방전량
                  </dt>
                  <dd>1 kWh</dd>
                </dl>
              </ValueBox>
            </InnerContent>
            <InnerContent>
              <ValueBox>
                <dl>
                  <dt>
                    <img
                      src="images/ctors/ems/database-power.png"
                      alt="생산전력"
                    />
                    일간 충전시간
                  </dt>
                  <dd>3h 15m</dd>
                </dl>
              </ValueBox>
              <ValueBox>
                <dl>
                  <dt>
                    <img
                      src="images/ctors/ems/database-power.png"
                      alt="생산전력"
                    />
                    일간 방전시간
                  </dt>
                  <dd>1h 10m</dd>
                </dl>
              </ValueBox>
            </InnerContent>
            <InnerContent>
              <ValueBox>
                <dl>
                  <dt>
                    <img
                      src="images/ctors/ems/database-power.png"
                      alt="생산전력"
                    />
                    누적 충전량
                  </dt>
                  <dd>1 kWh</dd>
                </dl>
              </ValueBox>
              <ValueBox>
                <dl>
                  <dt>
                    <img
                      src="images/ctors/ems/database-power.png"
                      alt="생산전력"
                    />
                    누적 충전시간
                  </dt>
                  <dd>3h 15m</dd>
                </dl>
              </ValueBox>
              <ValueBox>
                <dl>
                  <dt>
                    <img
                      src="images/ctors/ems/database-power.png"
                      alt="생산전력"
                    />
                    누적 발전량
                  </dt>
                  <dd>1 kWh</dd>
                </dl>
              </ValueBox>
              <ValueBox>
                <dl>
                  <dt>
                    <img
                      src="images/ctors/ems/database-power.png"
                      alt="생산전력"
                    />
                    누적 방전시간
                  </dt>
                  <dd>1h 10m</dd>
                </dl>
              </ValueBox>
            </InnerContent>
          </GridContainer>
        </GridContent>
      </>
    );
  }
}
const ValueBox = styled.div`
  margin-bottom: 10px;
  :last-child {
    margin-bottom: 0;
  }
  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
  dt,
  dd {
    display: inline-block;
    font-size: 0;
  }
  dt {
    font-size: 16px;
    width: 60%;
    color: #595959;
  }
  dd {
    width: 40%;
    font-size: 18px;
    font-weight: bold;
    text-align: right;
    color: #262626;
  }
`;
export default SystemInfo;
